import { HTTP_STATUS } from './constants';
export const buildQueryString = (params) => {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            if (Array.isArray(value)) {
                value.forEach(item => searchParams.append(key, String(item)));
            }
            else {
                searchParams.append(key, String(value));
            }
        }
    });
    return searchParams.toString();
};
export const createFormData = (data) => {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            if (Array.isArray(value)) {
                value.forEach(item => formData.append(key, item));
            }
            else if (value instanceof File || value instanceof Blob) {
                formData.append(key, value);
            }
            else {
                formData.append(key, String(value));
            }
        }
    });
    return formData;
};
export const createHeaders = {
    json: () => ({
        'Content-Type': 'application/json',
    }),
    formData: () => ({}),
    urlEncoded: () => ({
        'Content-Type': 'application/x-www-form-urlencoded',
    }),
    custom: (contentType) => ({
        'Content-Type': contentType,
    }),
};
export const transformResponse = {
    paginated: (response) => {
        const data = response;
        return {
            data: data.data || [],
            meta: {
                total: data.meta?.total || 0,
                page: data.meta?.page || 1,
                limit: data.meta?.limit || 10,
            },
        };
    },
    standard: (response) => {
        const data = response;
        return data.data || response;
    },
    file: (response) => {
        const data = response;
        return {
            blob: data.data || new Blob(),
            filename: data.headers?.['content-disposition']?.split('filename=')[1]?.replace(/"/g, '') || 'download',
        };
    },
};
export const withRetry = async (operation, maxRetries = 3, delay = 1000) => {
    let lastError;
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
            return await operation();
        }
        catch (error) {
            lastError = error;
            if (attempt === maxRetries) {
                throw lastError;
            }
            await new Promise(resolve => setTimeout(resolve, delay * attempt));
        }
    }
    throw lastError;
};
export const createCancellableRequest = () => {
    const controller = new AbortController();
    return {
        signal: controller.signal,
        cancel: () => controller.abort(),
    };
};
export const isNetworkError = (error) => {
    const err = error;
    return Boolean(err.request && !err.response);
};
export const isTimeoutError = (error) => {
    const err = error;
    if (err.code === 'ECONNABORTED' || err.code === 'TIMEOUT_ERROR') {
        return true;
    }
    if (err.status === HTTP_STATUS.GATEWAY_TIMEOUT) {
        return true;
    }
    return ['timeout', 'time out', 'timed out'].some(keyword => err.message?.includes(keyword));
};
export const isClientError = (error) => {
    const err = error;
    return Boolean(err.response?.status && err.response.status >= 400 && err.response.status < 500);
};
export const isServerError = (error) => {
    const err = error;
    return Boolean(err.response?.status && err.response.status >= 500);
};
export const transformErrorResponse = (response) => {
    const errorData = response.data;
    const errorDetails = response.details;
    const detailsResult = errorDetails?.result;
    return {
        status: response.status,
        result: {
            errorCode: errorData?.code || detailsResult?.code || response.status?.toString(),
            error: errorData?.error ||
                detailsResult?.error ||
                detailsResult?.code ||
                'API_ERROR',
            message: errorData?.message || detailsResult?.message || 'GENERIC',
        },
    };
};
